import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {Skeleton} from '../../common/skeleton';

/*
 * Props.
 */

interface CrmSyncDialogStepHeaderProps {
  step?: number;
  title?: ReactNode;
  description?: ReactNode;
  isDisabled?: boolean;
  isLoading?: boolean;
}

/*
 * Style.
 */

const StyledStepHeaderWrapperDiv = styled.div`
  margin-bottom: 16px;
`;

const StyledTitleWrapperDiv = styled.div`
  color: ${(p) => p.theme.greys.shade80};
  display: flex;
  flex-flow: row;
`;

const StyledStepNumberWrapperDiv = styled.div`
  position: relative;
  flex: 0 0 16px;
  margin-right: 8px;
`;

const StyledStepNumberDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  height: 16px;
  width: 16px;
  line-height: 14px;
  border-radius: 50%;
  border: 1px solid ${(p) => p.theme.greys.shade80};
  box-sizing: border-box;
  font-size: 9px;
  font-weight: ${fontWeights.black};
`;

const StyledStepTitleDiv = styled.div`
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.large};
  line-height: ${fontSizes.large};
`;

const StyledDescriptionWrapperDiv = styled.div`
  margin-top: 8px;
  color: ${(p) => p.theme.greys.shade70};
  line-height: 22px;
  font-size: ${fontSizes.medium};
`;

/*
 * Component.
 */

export const CrmSyncDialogStepHeader: FC<CrmSyncDialogStepHeaderProps> = (props) => {
  const {step, title, description, isLoading} = props;
  if (isLoading) {
    return renderLoadingState();
  }
  return (
    <StyledStepHeaderWrapperDiv>
      <StyledTitleWrapperDiv>
        <StyledStepNumberWrapperDiv>
          <StyledStepNumberDiv>{step}</StyledStepNumberDiv>
        </StyledStepNumberWrapperDiv>
        <StyledStepTitleDiv>{title}</StyledStepTitleDiv>
      </StyledTitleWrapperDiv>
      {description && <StyledDescriptionWrapperDiv>{description}</StyledDescriptionWrapperDiv>}
    </StyledStepHeaderWrapperDiv>
  );
};

/*
 * Helpers.
 */

function renderLoadingState() {
  return (
    <StyledStepHeaderWrapperDiv>
      <StyledTitleWrapperDiv>
        <StyledStepTitleDiv>
          <Skeleton height="16px" width="203px" />
        </StyledStepTitleDiv>
      </StyledTitleWrapperDiv>
    </StyledStepHeaderWrapperDiv>
  );
}
